export default {

  data: () => ({
    accountTypes: {
      d: {
        icon: 'fa-cash-register',
        iconBackGroundColor: 'text-success',
        typeDescription: 'Caixa diário',
        typeHint : 'Caixa para atendimento ao publico, com operação de abertura e fechamento (Exemplo: pdv)'
      },
      c: {
        icon: 'fa-piggy-bank',
        iconBackGroundColor: 'text-info',
        typeDescription: 'Conta caixa',
        typeHint : 'Caixa interno para controle financeiro da empresa, como (Exemplo: cofre ou gaveta)'
      },
      b: {
        icon: 'fa-university',
        iconBackGroundColor: 'text-primary',
        typeDescription: 'Conta bancária',
        typeHint : 'Contas em bancos ou instituições financeiras'
      }
    }
  }),
}